import {SET_DASHBOARD_INFO} from './index';

export function setDashboardInfo(info) {
  return {
    type: SET_DASHBOARD_INFO,
    value: info,
  };
}
